import React from "react";
import { STATUS_COLORS, COMMITMENT_STATUS, CATEGORY_COLORS, RELATION_COLORS } from "@/lib/utils-fos";

export function StatusDot({ status, size = 8 }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.active;
  return (
    <span
      className="inline-block rounded-full shrink-0"
      style={{ background: c.dot, width: size, height: size }}
    />
  );
}

export function StatusBadge({ status }) {
  const c = STATUS_COLORS[status] || STATUS_COLORS.active;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[11px] font-medium"
      style={{ background: c.bg, color: c.text }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: c.text }} />
      {c.label}
    </span>
  );
}

export function CommitmentBadge({ status }) {
  const c = COMMITMENT_STATUS[status] || COMMITMENT_STATUS.open;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium"
      style={{ background: c.bg, color: c.text }}
    >
      {c.label}
    </span>
  );
}

export function CategoryBadge({ category }) {
  const c = CATEGORY_COLORS[category] || CATEGORY_COLORS.custom;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium capitalize"
      style={{ background: c.bg, color: c.text }}
    >
      {(category || "custom")}
    </span>
  );
}

export function RelationBadge({ type }) {
  const c = RELATION_COLORS[type] || RELATION_COLORS.team;
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 rounded text-[10px] font-medium capitalize"
      style={{ background: c.bg, color: c.text }}
    >
      {(type || "team")}
    </span>
  );
}

export function HealthBar({ score }) {
  const color = score >= 70 ? "#0A0A0A" : score >= 40 ? "#FF9F0A" : "#FF453A";
  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-1.5 rounded-full overflow-hidden" style={{ background: "#E5E5E5" }}>
        <div className="h-full rounded-full" style={{ width: `${score}%`, background: color }} />
      </div>
      <span className="text-[11px] mono font-semibold" style={{ color }}>
        {score}
      </span>
    </div>
  );
}
